/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from '@mui/styles';

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";


import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";

const useStyles = makeStyles(aboutUsStyle);

export default function Tarifas() {
  const downloadPdfFromJson = async (jsonUrl, filename) => {
    const response = await fetch(jsonUrl);
    if (!response.ok) {
      throw new Error("No se pudo cargar el archivo");
    }

    const payload = await response.json();
    const binary = atob(payload.data);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: payload.contentType || "application/pdf" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename || payload.filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  return (
    <div>
      <Parallax image={require("assets/img/sections/bucaramanga.jpg")} filter="dark" small>
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem
              md={8}
              sm={8}
              className={classNames(
                classes.mlAuto,
                classes.mrAuto,
                classes.textCenter
              )}
            >
              <h1 className={classes.title}>Tarifas</h1>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container} style={{paddingTop:'50px', paddingBottom:'30px'}}>
          <center className="mt-5">
            <a href={"https://drive.google.com/file/d/1XQckGExaqcynn5fDsHzwYIxvuUstsU7z/view?usp=sharing"} style={{textDecoration: "none !important"}} target="_blank">
              <img
                alt="Imagen con referencia hacia un icono para descargar un archivo en PDF"
                width="80px"
                src={require("assets/img/sections/pdf.jpg")}
              ></img>
              <h6 className="my-3">Decreto 1000 de 2015</h6>
            </a>
          </center>
          <center className="mt-5">
            <a
              href="#tarifas-2026"
              role="button"
              style={{textDecoration: "none !important", cursor: "pointer"}}
              onClick={(e) => {
                e.preventDefault();
                downloadPdfFromJson(
                  `${process.env.PUBLIC_URL}/tarifas-notariales-2026.json`,
                  "RES-tarifas-notariales-2026-000964-6.pdf"
                );
              }}
            >
              <img
                alt="Tarifas notariales 2026 en PDF"
                width="80px"
                src={require("assets/img/sections/pdf.jpg")}
              ></img>
              <h6 className="my-3">TARIFAS NOTARIALES 2026</h6>
            </a>
          </center>
          <center className="mt-5">
            <a href={"https://drive.google.com/file/d/1-yVGv4E9rdZjAAbnE0oBkfQRSAtRcHXu/view?usp=sharing"} style={{textDecoration: "none !important"}} target="_blank">
              <img
                alt="Imagen con referencia hacia un icono para descargar un archivo en PDF"
                width="80px"
                src={require("assets/img/sections/pdf.jpg")}
              ></img>
              <h6 className="my-3">Tarifas DTR SRD</h6>
            </a>
          </center>
        </div>
      </div>
    </div>
  );
}
